import { EyeOff, Globe, ScanEye, Building2, Save, Server } from 'lucide-react';
import SeriesTemplate from '../components/SeriesTemplate';

const MiniHiddenFisheye = () => {
  const features = [
    {
      Icon: EyeOff,
      title: '目立ちにくい設置に対応',
      desc: '小型ドームや隠しやすいデザインにより、内装や意匠を損ないにくいカメラです。',
    },
    {
      Icon: Globe,
      title: 'フィッシュアイ広角撮影',
      desc: '1台で室内をほぼ全周確認でき、店舗や受付などの見取り確認に適しています。',
    },
    {
      Icon: ScanEye,
      title: '動体検知・通知',
      desc: '室内での動きを検知し、通知や録画に連携できます。',
    },
    {
      Icon: Building2,
      title: '室内設置に最適',
      desc: '店舗・受付・小規模スペースなど、室内の見通し確認に向いています。',
    },
    {
      Icon: Save,
      title: 'microSD対応モデル',
      desc: '本体側でのバックアップ録画にも対応するモデルがあります。',
    },
    {
      Icon: Server,
      title: 'NVR・録画機器と連携',
      desc: '他のカメラと組み合わせて、施設全体の録画構成を作れます。',
    },
  ];

  const notes = [
    'フィッシュアイ画像は特有の歪みがあります。用途に応じてデワープ表示との使い分けが必要です。',
    '屋内向けの設計のため、屋外設置には防水ハウジングや別モデルの検討が必要です。',
    '機種や設定内容により、使用できる機能が異なる場合があります。',
  ];

  return (
    <SeriesTemplate
      id="mini"
      eyebrow="MINI / FISHEYE"
      name="Mini Hidden & Fisheyeシリーズ"
      description="目立ちにくい設置や、室内を広く確認したい場合に向いた防犯カメラシリーズです。店舗、受付、小規模スペースなどで使いやすい構成です。"
      tags={['小型', 'フィッシュアイ', '4MP', 'PoE対応', '目立ちにくい', '遠隔確認']}
      features={features}
      locations={['店舗内', '受付・エントランス', '小規模オフィス', '会議室', '医療施設内', '室内共用部']}
      notes={notes}
    />
  );
};

export default MiniHiddenFisheye;
